import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/ua/apps/',
    component: ComponentCreator('/ua/apps/', '7d0'),
    exact: true
  },
  {
    path: '/ua/blog/',
    component: ComponentCreator('/ua/blog/', '16f'),
    exact: true
  },
  {
    path: '/ua/blog/archive/',
    component: ComponentCreator('/ua/blog/archive/', '1bc'),
    exact: true
  },
  {
    path: '/ua/blog/authors/',
    component: ComponentCreator('/ua/blog/authors/', '82d'),
    exact: true
  },
  {
    path: '/ua/blog/bitcoin-block-streaming-grpc-vs-json-rpc/',
    component: ComponentCreator('/ua/blog/bitcoin-block-streaming-grpc-vs-json-rpc/', '4a2'),
    exact: true
  },
  {
    path: '/ua/blog/bitcoin-fee-estimation-rbf-cpfp-batch-guide/',
    component: ComponentCreator('/ua/blog/bitcoin-fee-estimation-rbf-cpfp-batch-guide/', '77f'),
    exact: true
  },
  {
    path: '/ua/blog/bitcoin-fee-estimation-wallet-integration/',
    component: ComponentCreator('/ua/blog/bitcoin-fee-estimation-wallet-integration/', '24c'),
    exact: true
  },
  {
    path: '/ua/blog/bitcoin-mempool-fee-spikes-developer-guide/',
    component: ComponentCreator('/ua/blog/bitcoin-mempool-fee-spikes-developer-guide/', 'f27'),
    exact: true
  },
  {
    path: '/ua/blog/bitcoin-rpc-vs-indexed-api-developers/',
    component: ComponentCreator('/ua/blog/bitcoin-rpc-vs-indexed-api-developers/', '4e8'),
    exact: true
  },
  {
    path: '/ua/blog/custom-blockchain-indexer-what-it-takes/',
    component: ComponentCreator('/ua/blog/custom-blockchain-indexer-what-it-takes/', 'ee4'),
    exact: true
  },
  {
    path: '/ua/blog/evm-eip1559-gas-fee-estimation-guide/',
    component: ComponentCreator('/ua/blog/evm-eip1559-gas-fee-estimation-guide/', 'f42'),
    exact: true
  },
  {
    path: '/ua/blog/how-bitcoin-fees-work/',
    component: ComponentCreator('/ua/blog/how-bitcoin-fees-work/', '39c'),
    exact: true
  },
  {
    path: '/ua/blog/how-to-backfill-bitcoin-indexer-fast/',
    component: ComponentCreator('/ua/blog/how-to-backfill-bitcoin-indexer-fast/', '9fb'),
    exact: true
  },
  {
    path: '/ua/blog/managed-blockchain-indexer-vs-self-hosted/',
    component: ComponentCreator('/ua/blog/managed-blockchain-indexer-vs-self-hosted/', 'f57'),
    exact: true
  },
  {
    path: '/ua/blog/pay-as-you-go-vs-subscription-blockchain-api/',
    component: ComponentCreator('/ua/blog/pay-as-you-go-vs-subscription-blockchain-api/', '058'),
    exact: true
  },
  {
    path: '/ua/blog/tags/',
    component: ComponentCreator('/ua/blog/tags/', 'd75'),
    exact: true
  },
  {
    path: '/ua/blog/tags/api/',
    component: ComponentCreator('/ua/blog/tags/api/', '2f5'),
    exact: true
  },
  {
    path: '/ua/blog/tags/backfill/',
    component: ComponentCreator('/ua/blog/tags/backfill/', '4f5'),
    exact: true
  },
  {
    path: '/ua/blog/tags/billing/',
    component: ComponentCreator('/ua/blog/tags/billing/', 'b71'),
    exact: true
  },
  {
    path: '/ua/blog/tags/bitcoin/',
    component: ComponentCreator('/ua/blog/tags/bitcoin/', '747'),
    exact: true
  },
  {
    path: '/ua/blog/tags/blockchain/',
    component: ComponentCreator('/ua/blog/tags/blockchain/', '3a3'),
    exact: true
  },
  {
    path: '/ua/blog/tags/cost/',
    component: ComponentCreator('/ua/blog/tags/cost/', 'c46'),
    exact: true
  },
  {
    path: '/ua/blog/tags/cpfp/',
    component: ComponentCreator('/ua/blog/tags/cpfp/', '1c3'),
    exact: true
  },
  {
    path: '/ua/blog/tags/data/',
    component: ComponentCreator('/ua/blog/tags/data/', '4be'),
    exact: true
  },
  {
    path: '/ua/blog/tags/development/',
    component: ComponentCreator('/ua/blog/tags/development/', '3f8'),
    exact: true
  },
  {
    path: '/ua/blog/tags/eip-1559/',
    component: ComponentCreator('/ua/blog/tags/eip-1559/', '825'),
    exact: true
  },
  {
    path: '/ua/blog/tags/ethereum/',
    component: ComponentCreator('/ua/blog/tags/ethereum/', 'f96'),
    exact: true
  },
  {
    path: '/ua/blog/tags/evm/',
    component: ComponentCreator('/ua/blog/tags/evm/', '57b'),
    exact: true
  },
  {
    path: '/ua/blog/tags/fees/',
    component: ComponentCreator('/ua/blog/tags/fees/', 'a36'),
    exact: true
  },
  {
    path: '/ua/blog/tags/gas/',
    component: ComponentCreator('/ua/blog/tags/gas/', '731'),
    exact: true
  },
  {
    path: '/ua/blog/tags/grpc/',
    component: ComponentCreator('/ua/blog/tags/grpc/', 'dd0'),
    exact: true
  },
  {
    path: '/ua/blog/tags/indexer/',
    component: ComponentCreator('/ua/blog/tags/indexer/', 'e65'),
    exact: true
  },
  {
    path: '/ua/blog/tags/infrastructure/',
    component: ComponentCreator('/ua/blog/tags/infrastructure/', 'bdc'),
    exact: true
  },
  {
    path: '/ua/blog/tags/integration/',
    component: ComponentCreator('/ua/blog/tags/integration/', 'e18'),
    exact: true
  },
  {
    path: '/ua/blog/tags/mempool/',
    component: ComponentCreator('/ua/blog/tags/mempool/', 'cb2'),
    exact: true
  },
  {
    path: '/ua/blog/tags/performance/',
    component: ComponentCreator('/ua/blog/tags/performance/', '6bd'),
    exact: true
  },
  {
    path: '/ua/blog/tags/polygon/',
    component: ComponentCreator('/ua/blog/tags/polygon/', '2ba'),
    exact: true
  },
  {
    path: '/ua/blog/tags/pricing/',
    component: ComponentCreator('/ua/blog/tags/pricing/', '584'),
    exact: true
  },
  {
    path: '/ua/blog/tags/rbf/',
    component: ComponentCreator('/ua/blog/tags/rbf/', 'c17'),
    exact: true
  },
  {
    path: '/ua/blog/tags/streaming/',
    component: ComponentCreator('/ua/blog/tags/streaming/', '202'),
    exact: true
  },
  {
    path: '/ua/blog/tags/wallet/',
    component: ComponentCreator('/ua/blog/tags/wallet/', '10d'),
    exact: true
  },
  {
    path: '/ua/policy/',
    component: ComponentCreator('/ua/policy/', 'de8'),
    exact: true
  },
  {
    path: '/ua/pricing/',
    component: ComponentCreator('/ua/pricing/', '463'),
    exact: true
  },
  {
    path: '/ua/sandbox/',
    component: ComponentCreator('/ua/sandbox/', '90b'),
    exact: true
  },
  {
    path: '/ua/security/',
    component: ComponentCreator('/ua/security/', 'f6f'),
    exact: true
  },
  {
    path: '/ua/terms/',
    component: ComponentCreator('/ua/terms/', 'd4f'),
    exact: true
  },
  {
    path: '/ua/docs/',
    component: ComponentCreator('/ua/docs/', '32d'),
    routes: [
      {
        path: '/ua/docs/',
        component: ComponentCreator('/ua/docs/', 'cb8'),
        routes: [
          {
            path: '/ua/docs/',
            component: ComponentCreator('/ua/docs/', '683'),
            routes: [
              {
                path: '/ua/docs/',
                component: ComponentCreator('/ua/docs/', 'cb0'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/',
                component: ComponentCreator('/ua/docs/apps/', '70b'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/bitcoin-fees-advisor/',
                component: ComponentCreator('/ua/docs/apps/bitcoin-fees-advisor/', 'e9c'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/bitcoin-fees-advisor/api-reference/',
                component: ComponentCreator('/ua/docs/apps/bitcoin-fees-advisor/api-reference/', '539'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/bitcoin-fees-advisor/examples/',
                component: ComponentCreator('/ua/docs/apps/bitcoin-fees-advisor/examples/', '8ec'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/custom-indexers/',
                component: ComponentCreator('/ua/docs/apps/custom-indexers/', 'd37'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/evm-fees-advisor/',
                component: ComponentCreator('/ua/docs/apps/evm-fees-advisor/', '93b'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/evm-fees-advisor/api-reference/',
                component: ComponentCreator('/ua/docs/apps/evm-fees-advisor/api-reference/', '467'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/evm-fees-advisor/examples/',
                component: ComponentCreator('/ua/docs/apps/evm-fees-advisor/examples/', '211'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/indexed-data-apps/',
                component: ComponentCreator('/ua/docs/apps/indexed-data-apps/', 'f18'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/stream-app/',
                component: ComponentCreator('/ua/docs/apps/stream-app/', '334'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/stream-app/examples/',
                component: ComponentCreator('/ua/docs/apps/stream-app/examples/', '438'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/stream-app/formats/',
                component: ComponentCreator('/ua/docs/apps/stream-app/formats/', '186'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/apps/stream-app/grpc-reference/',
                component: ComponentCreator('/ua/docs/apps/stream-app/grpc-reference/', 'cee'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/getting-started/',
                component: ComponentCreator('/ua/docs/getting-started/', '10f'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/getting-started/authentication/',
                component: ComponentCreator('/ua/docs/getting-started/authentication/', '9b6'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/getting-started/billing/',
                component: ComponentCreator('/ua/docs/getting-started/billing/', '2e5'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/reference/error-codes/',
                component: ComponentCreator('/ua/docs/reference/error-codes/', '1e2'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/ua/docs/reference/rate-limits/',
                component: ComponentCreator('/ua/docs/reference/rate-limits/', 'bd1'),
                exact: true,
                sidebar: "docs"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/ua/',
    component: ComponentCreator('/ua/', 'ae9'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
